import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateVeryHappyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2A14 14 0 1 1 2 16 14 14 0 0 1 16 2m6.08 15.43H9.81a1 1 0 0 0-.89 1c0 3.07 3.39 6.13 7.08 6.13s7.08-3.06 7.08-6.13a1 1 0 0 0-1-1M12 11a2 2 0 1 0 2 2 2 2 0 0 0-2-2m8 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2" />
  </svg>
);
const ForwardRef = forwardRef(IconRateVeryHappyFilledSVG);
ForwardRef.displayName = "IconRateVeryHappyFilled";
export { ForwardRef as IconRateVeryHappyFilled };
